import { useNavigate } from "react-router-dom";

import useListMedal from "../hooks/useListMedal";
import Medal from "../interfaces/medal";
import { ASSETS_URL } from "../util/constants";
import "./Collectionables.css";

const getCollectionableImageUrl = (medal: Medal) => {
  const path = medal.pathImage.startsWith(".")
    ? medal.pathImage.slice(1)
    : medal.pathImage;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const hasExtension = /\.[a-z0-9]+$/i.test(normalizedPath);

  return `${ASSETS_URL}${normalizedPath}${hasExtension ? "" : ".png"}`;
};

function Collectionables() {
  const navigate = useNavigate();
  const { data: medals, isLoading, error } = useListMedal();

  const collectionables = medals
    ? medals.filter((medal) => medal.medalType.slug === "collectionables")
    : [];

  return (
    <main className="collectionables-page">
      <div className="collectionables-header">
        <div>
          <span className="collectionables-kicker">Collectionables</span>
          <h1>All Collectionables</h1>
        </div>
        <button
          className="collectionables-back-link"
          type="button"
          onClick={() => navigate(-1)}
        >
          Back to profile
        </button>
      </div>

      <section className="collectionables-request-info">
        <h2>How to redeem</h2>
        <p>
          To redeem a collectionable, you need to have proof of completing the challenge.
          Once you have a proof that you completed the challenge, you can submit it to the #claim-your-badge channel on <a href="https://discord.gg/xtqDSm7wBT" target="_blank" rel="noopener noreferrer">Discord</a>.
        </p>
      </section>

      {isLoading ? (
        <p className="collectionables-status">Loading collectionables...</p>
      ) : error ? (
        <p className="collectionables-status">
          Error loading collectionables.
        </p>
      ) : collectionables.length === 0 ? (
        <p className="collectionables-status">
          There are no collectionables to display.
        </p>
      ) : (
        <div className="collectionables-grid">
          {collectionables.map((medal) => (
            <article className="collectionable-card" key={medal.id ?? medal.name}>
              <div className="collectionable-image-wrap">
                <img
                  src={getCollectionableImageUrl(medal)}
                  alt={medal.name}
                  className="collectionable-image"
                />
              </div>
              <div className="collectionable-copy">
                <h2>{medal.name}</h2>
                <p>{medal.description || "No description provided."}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </main>
  );
}

export default Collectionables;
